<template>
  <div>
    <v-btn outlined color="primary" class="ml-1" @click="updatePlaylist" v-if="isAdmin">
      <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">list</i>
      <span class="d-none d-sm-block">{{ $t('display/elevator:overview.custom-panel.update-playlists') }}</span>
    </v-btn>
    <v-btn outlined color="primary" class="ml-1" @click="reloadTable">
      <i aria-hidden="true" class="v-icon notranslate material-icons theme--light">sync</i>
    </v-btn>
  </div>
</template>

<script>

export default {
  name: "TablePanel",
  props: {
    isAdmin: Boolean
  },
  methods: {
    updatePlaylist() {
      this.$emit('updatePlaylist');
    },
    reloadTable() {
      this.$emit('reloadTable');
    }
  }
}
</script>